var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive } from 'angular-ts-decorators';
export function togglePasswordVisibility(e) {
    const target = e.target;
    const passwordFieldElement = target.previousElementSibling;
    if (passwordFieldElement.getAttribute('type') === 'password') {
        target.setAttribute('class', 'fa-extension fa-eye-slash-solid password-icon');
        passwordFieldElement.setAttribute('type', 'text');
    }
    else {
        target.setAttribute('class', 'fa-extension fa-eye-solid password-icon');
        passwordFieldElement.setAttribute('type', 'password');
    }
}
let ExposePasswordDirective = class ExposePasswordDirective {
};
ExposePasswordDirective = __decorate([
    Directive({
        selector: 'expose-password',
        link: function (_scope, element, _attrs) {
            element.on('click', togglePasswordVisibility);
        },
    })
], ExposePasswordDirective);
export { ExposePasswordDirective };
